import React from "react";

const threshold = 0;
export default function useInViewPort(isMapVisible: boolean) {
  const nodeRef = React.useRef(null);
  const observerRef = React.useRef(null);
  const [isVisible, setIsVisible] = React.useState(false);


  React.useEffect(() => {
    observerRef.current = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      }, { threshold });
  }, []);

  React.useEffect(() => {
    observerRef.current.observe(nodeRef?.current);

    return () => {
      if (observerRef && observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, [nodeRef]);

  React.useEffect(() => {
    if (isVisible && isMapVisible) {
      observerRef.current.unobserve(nodeRef?.current);
    }
  }, [isMapVisible, isVisible]);

  return [nodeRef, isVisible];
}
